module.exports = __webpack_public_path__ + "ff348ba1ede42ef3ee83755e4dd4f62c.svg";